import * as React from 'react';

import { cn } from '../../lib/utils';

// MD3 filled text field: rounded top / square bottom, Surface Container Low
// fill, 2px bottom border in Outline at rest -> Primary on focus. Icon-left
// padding (e.g. a search glyph) is composed externally by the caller via a
// wrapper div + `pl-10`, same as the existing SearchBar/TokenInput pattern —
// this primitive stays icon-agnostic.
//
// forwardRef: this app is React 18 (unlike frontend/'s React 19), where a
// plain function component silently drops a `ref` prop instead of forwarding
// it — needed for real call sites like BottomNav's autofocus-on-mount input.
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'bg-muted text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground',
          'h-14 w-full min-w-0 rounded-t-xl rounded-b-none border-b-2 border-outline px-4 py-2 text-base transition-[color,border-color] duration-200 ease-emphasized-decelerate outline-none',
          'hover:border-foreground',
          'focus-visible:border-primary',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
